import { useEffect } from 'react';
import { useMessageStore } from '@/stores/useMessageStore.js';
import { getGlobalVirtualMessageAdapter } from '@/infrastructure/adapters/VirtualMessageAdapter.js';
import { mockMessages } from '@/mock/data.js';

export const useVirtualMessageBus = () => {
  const addMessage = useMessageStore((s) => s.addMessage);
  const setMessages = useMessageStore((s) => s.setMessages);

  useEffect(() => {
    const adapter = getGlobalVirtualMessageAdapter();
    if (adapter.getHistory().length === 0) {
      mockMessages.forEach((m) => adapter.publish(m));
      setMessages(adapter.getHistory());
    }

    const unsubscribe = adapter.subscribe((message) => {
      addMessage(message);
    });

    return () => {
      unsubscribe();
    };
  }, [addMessage, setMessages]);
};
